import * as angular from 'angular';
import { CheckinAncillariesConstants } from '@src/app/core/constants/ib-ancillaries-constants';
import { CommonsSessionStorageService } from 'ib-web-commons/utils/storage-utils/ib-commons-session-storage.service';
export class CallAncillariesService {

    constructor (
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy,
        private $filter: angular.IFilterService
    ) {}

    getAncillaries = () => {
        let locator = '';
        const bookingInfo: any = this.CommonsSessionStorageService.get('bookingInfo');
        if (bookingInfo?.order?.bookingReferences?.length > 0) {
            locator = bookingInfo.order.bookingReferences[0].reference;
            this.CommonsSessionStorageService.set('PNR', locator);
        }
        const flowId = this.CommonsSessionStorageService.get('flowId');
        const endpoint = `${CheckinAncillariesConstants.DEFAULT_ENDPOINTS.ancillariesURI}${flowId}/ancillaries?locator=` + locator;

        const maxEditableTimeout :number = this.CommonsSessionStorageService.get('ancillariesServiceTimeoutValue')|| null;
        return new Promise((resolve, reject) => {
            if (flowId !== null) {
                this.CommonsGenericProxy.getGeneric(endpoint, null, maxEditableTimeout).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });

            } else {
                reject({
                    errorCode: 'IB_00002',
                    message: this.$filter<any>('translate')('SESSION_EXPIRED'),
                    internalErrorCode: 'IB_00002'
                });
            }
        });
    };

    getInsurance = (country: string) => {
        const checkinId = this.CommonsSessionStorageService.get('flowId');
        const endpoint = CheckinAncillariesConstants.DEFAULT_ENDPOINTS.ancillariesURI;
        const uri = endpoint + checkinId + '/ancillaries' + '?ancillaryType=INSURANCE&residenceCountry=' + country;
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(uri).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };

    getUpgradingBidAncillarie = () => {
        const checkinId = this.CommonsSessionStorageService.get('flowId');
        const endpoint = CheckinAncillariesConstants.DEFAULT_ENDPOINTS.ancillariesURI;
        const uri = endpoint + checkinId + '/ancillaries' + '?ancillaryType=UPGRADING_BID';
        return new Promise((resolve, reject) => {
            this.CommonsGenericProxy.getGeneric(uri).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                });
        });
    };
}

CallAncillariesService.$inject = ['CommonsSessionStorageService', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy', '$filter'];
try {
    const mod = angular.module('ib-shared-services-module');
    mod.service(
        'CallAncillariesService',
        CallAncillariesService
    );
} catch (error) {
    const mod = angular.module('ib-shared-services-module', []);
    mod.service(
        'CallAncillariesService',
        CallAncillariesService
    );
}
